import React, { useCallback } from "react";
import FetchHook from "../../Api/FetchHooks";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { useEffect } from "react";
import TableComponent from "../../Components/TableComponent";
import PageLoader from "../../Components/PageLoader";
import DateRangePicker from "../../Components/DateRangePicker";
import { AllInbox } from "@mui/icons-material";
import Page from "../../Components/Page";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import AlertComponent from "../../Components/AlertComponent";
import ErrorDisplay from "../../Components/ErrorDisplay";
import UseServerTable from "../../Hooks/UseServerTable";
import { formatCurrencyV2, formatDate } from "../../utils/helpers";

const SavingsReport = () => {
  const location = useLocation();
  const loggedInUser = useSelector((state) => state?.auth?.user);

  const [startDate, setStartDate] = useState(new Date("2025-01-01"));
  const [endDate, setEndDate] = useState(new Date());
  const [status, setStatus] = useState("");

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [user, setUser] = useState(location?.state?.user || loggedInUser);
  const [data, setData] = useState([]);

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const start = moment(startDate).format("YYYY-MM-DD");
  const end = moment(endDate).format("YYYY-MM-DD");

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `main_report?type=saving_wallet&status=${status}&start_date='${start}'&end_date='${end}'`,
    onSuccess: (data) => {
      setData(data.Report);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  // const [loading, response, request] = FetchHook();

  // const fetchData = useCallback(async () => {
  //   try {
  //     const start = moment(startDate).format("YYYY-MM-DD");
  //     const end = moment(endDate).format("YYYY-MM-DD");
  //     await request({
  //       url: `/loan_report?status=${status}&start_date='${start}'&end_date='${end}'`,
  //     });
  //   } catch (error) {
  //     const errorMessage =
  //       error.response?.data?.StatusMessage ??
  //       error.response?.data?.message ??
  //       error.message ??
  //       "An unexpected error occurred. Please try again.";

  //     setSnackbar({
  //       open: true,
  //       severity: "error",
  //       message: errorMessage,
  //     });
  //   }
  // }, [status]);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  // useEffect(() => {
  //   if (response && response.status === 200 && response.data.StatusCode === 0) {
  //     setData(response.data.Report);
  //   }
  // }, [response]);

  const columns = [
    {
      field: "msisdn",
      headerName: "Phone Number",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "debit",
      headerName: "Debit",
      minWidth: 100,
      flex: 1,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "credit",
      headerName: "Credit",
      minWidth: 100,
      flex: 1,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "balance_before",
      headerName: "Balance before",
      minWidth: 150,
      flex: 1,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "balance_after",
      headerName: "Balance after",
      minWidth: 150,
      flex: 1,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "transaction_timestamp",
      headerName: "Transaction Date",
      minWidth: 200,
      flex: 1,
      valueFormatter: (params) => formatDate(params?.value),
    },
  ];

  return (
    <Page title={"Savings Report"}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Card>
        <CardHeader
          action={
            <Box sx={{ my: 2, display: "flex", gap: 2 }}>
              {/* <FormControl sx={{ width: "150px" }}>
                <InputLabel id="status" size="small">
                  Status
                </InputLabel>

                <Select
                  labelId="loan_status"
                  id="loan_status"
                  value={status}
                  label="status"
                  onChange={(e) => {
                    setStatus(e.target.value);
                  }}
                  size="small"
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                  <MenuItem value="domant">Dormant</MenuItem>
                  <MenuItem value="suspended">Suspended</MenuItem>
                  <MenuItem value="closed">Closed</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="cancelled">Cancelled</MenuItem>
                  <MenuItem value="incomplete">Incomplete</MenuItem>
                  <MenuItem value="complete">Complete</MenuItem>
                </Select>
              </FormControl> */}

              <DateRangePicker
                startDate={startDate}
                endDate={endDate}
                onStartDateChange={setStartDate}
                onEndDateChange={setEndDate}
                onSearch={refresh}
                loading={gridProps.loading}
              />
            </Box>
          }
        />
        <CardContent>
          {data && data.length > 0 ? (
            <TableComponent
              data={data}
              columns={columns}
              sortModel={[
                {
                  field: "transaction_timestamp",
                  sort: "desc",
                },
              ]}
              {...gridProps}
            />
          ) : data && data.length <= 0 && gridProps.loading ? (
            <Grid display={"flex"} justifyContent={"center"}>
              <CircularProgress />
            </Grid>
          ) : (
            <ErrorDisplay
              message="No Data Found!"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default SavingsReport;
